import React, { Component } from 'react'
import { Area, Parking, Zone, Floor } from './icons'

class AreaParkingZone extends Component {

  render() {

    let { color, type, carports, garages, openSpaces, landAreaValue, landAreaUnits, floorAreaUnits, floorAreaValue } = this.props

    let parking = ( carports > 0 ? carports : 0 ) + ( garages > 0 ? garages : 0 ) + ( openSpaces > 0 ? openSpaces : 0 )

    return (
      <section className='area-parking-zone'>

        <div className='area-parking-zone__inner'>

          <div className='area-parking-zone__content'>

            <div className='area-parking-zone__list'>

              <ul>
                { landAreaValue > 0 && <li><Area color={color} /><span>{ landAreaValue }{ landAreaUnits }</span></li> }
                { floorAreaValue > 0 && <li><Floor color={color} /><span>{ floorAreaValue }{ floorAreaUnits }</span></li> }
                { parking > 0 && <li><Parking color={color} /><span>{ parking }</span></li> }
                { type && <li><Zone color={color} /><span>{ type }</span></li> }
              </ul>
            
            </div>

          </div>

        </div>

      </section>
    )
  }
}

export default AreaParkingZone
